import React, { createContext, useContext, useState, useEffect } from "react";

// Create the AuthContext
const AuthContext = createContext();

// AuthProvider component to wrap around app
export const AuthProvider = ({ children }) => {
  // Initialize authState from localStorage
  const [authState, setAuthState] = useState(() => {
    const savedAuthState = localStorage.getItem("authState");
    return savedAuthState
      ? JSON.parse(savedAuthState)
      : { user: null, roles: "", isAuthenticated: false };
  });

  // Function to update authState and persist it in localStorage
  const setAuthInfo = (user, roles) => {
    const updatedAuthState = {
      user,
      roles,
      isAuthenticated: !!user, // Set isAuthenticated based on user existence
    };
    setAuthState(updatedAuthState);
    localStorage.setItem("authState", JSON.stringify(updatedAuthState));
  };

  // Clear authState and remove it from localStorage on logout
  const logout = () => {
    setAuthState({ user: null, roles: "", isAuthenticated: false });
    localStorage.removeItem("authState");
  };

  return (
    <AuthContext.Provider value={{ authState, setAuthInfo, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);
